import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
/**
 * Tabs are links displaying the content of a pane
 *
 * @param {Array} children - Interactive links displaying tabs on click
 * @param {string} className - className needed by styled components
 *
 * @return {jsx}
 */

var Tabs = function Tabs(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    role: "tablist"
  }, children);
};
/**
 * PropTypes Validation
 */


var node = PropTypes.node,
    string = PropTypes.string;
Tabs.propTypes = {
  children: node.isRequired,
  className: string
};
/**
 * Default props.
 */

Tabs.defaultProps = {
  className: undefined
};
var StyledTabs = styled(Tabs).withConfig({
  displayName: "Tabs__StyledTabs",
  componentId: "sc-1ck3quv-0"
})(["display:flex;border-bottom:1px solid ", ";"], function (_ref2) {
  var palette = _ref2.theme.palette;
  return palette.lightGrey;
});
StyledTabs.displayName = 'Tabs';
export default StyledTabs;